import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DeletionEmailActions"] */ "/app/src/app/data-deletion/DeletionEmailActions.tsx");
